import { AccessLevelEnum } from '../core/enums/access-level.enum';
import { UserFunctionEnum } from '../core/enums/user-function.enum';
import { UserRolesOrgUnit, UserRolesOrgUnitDto } from '../core/models/user-roles-org-unit-dto';

export const userMngFncList = [
  UserFunctionEnum.UserManagement,
  UserFunctionEnum.CaRoleManagement,
  UserFunctionEnum.PlanningRoleManagement,
  UserFunctionEnum.PoolRoleManagement,
  UserFunctionEnum.SmRoleManagement,
];

export function isOrgUnitEditable(
  data: UserRolesOrgUnit,
  userFnc: UserFunctionEnum,
  userRolesWithOrgUnits: UserRolesOrgUnitDto[],
): boolean {
  const userPermissionList = userRolesWithOrgUnits.filter((value) =>
    value.role.functionPermissions.some((r) => r.userFunction === userFnc && r.permission === AccessLevelEnum.Write),
  );

  if (userPermissionList.length > 0) {
    return userPermissionList.some((r) => r.orgUnit.id === data.orgUnit.id);
  } else {
    return false;
  }
}

export function getUserPermittedOrgUnitIds(userRolesWithOrgUnits: UserRolesOrgUnitDto[]): number[] {
  return userRolesWithOrgUnits
    .filter((value) =>
      value.role.functionPermissions.some(
        (r) => userMngFncList.includes(r.userFunction) && r.permission === AccessLevelEnum.Write,
      ),
    )
    .map((value) => value.orgUnit.id)
    .filter((value, index, array) => array.indexOf(value) === index);
}
